import { defineModel } from "../define-model";

export type SystemRoleKey = "owner" | "admin" | "member" | "viewer";

export type WorkspaceRole = {
	id: string;
	workspaceId: string;
	name: string;
	description: string;
	/** Set on the four built-in roles; `null` for custom roles. */
	systemKey: SystemRoleKey | null;
	permissions: string[];
	createdById: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		workspaceRole: WorkspaceRole;
	}
}

const SYSTEM_ORDER: Record<SystemRoleKey, number> = { owner: 0, admin: 1, member: 2, viewer: 3 };

export const model = defineModel({
	name: "workspaceRole",
	load: "eager",
	sort: (a, b) =>
		(a.systemKey ? SYSTEM_ORDER[a.systemKey] : 9) - (b.systemKey ? SYSTEM_ORDER[b.systemKey] : 9) ||
		a.createdAt.localeCompare(b.createdAt),
});
